var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 13.3333H5.00004C4.07957 13.3333 3.33337 12.5871 3.33337 11.6666V4.99998C3.33337 4.07951 4.07957 3.33331 5.00004 3.33331H11.6667C12.5872 3.33331 13.3334 4.07951 13.3334 4.99998V6.66665M8.33337 16.6666H15C15.9205 16.6666 16.6667 15.9205 16.6667 15V8.33331C16.6667 7.41284 15.9205 6.66665 15 6.66665H8.33337C7.4129 6.66665 6.66671 7.41284 6.66671 8.33331V15C6.66671 15.9205 7.4129 16.6666 8.33337 16.6666Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDuplicate);
export default __webpack_public_path__ + "static/media/BlueDuplicate.56852b0ed7353245a62e761a76687c4d.svg";
export { ForwardRef as ReactComponent };